import { AssignmentStatus } from '../models/assignable-device.model';
import { GridStatus } from '../../../shared/components/grid/models/grid.model';

/** Maps a device's assignment status to the shared grid's status renderer
 *  (dot + label) — used by both the Assign devices tab (per-tenant grids)
 *  and the Rollout tab (fleet-wide device table) so the same status always
 *  looks the same everywhere it appears. */
export function assignmentGridStatus(status: AssignmentStatus, failedReason: string | null): GridStatus {
  switch (status) {
    case 'ok':
      return { label: 'Installed', color: 'green' };
    case 'failed':
      return { label: failedReason ? `Failed · ${failedReason}` : 'Failed', color: 'red' };
    case 'pending':
      return { label: 'Pending', color: 'blue', hollow: true };
    case 'downloading':
      return { label: 'Downloading', color: 'blue' };
    case 'installing':
      return { label: 'Installing', color: 'blue' };
    case 'not_assigned':
      return { label: 'Not assigned', color: 'neutral', hollow: true };
  }
}
